import config from '../utils/ApiUrl';

const API_URL = config.API_URL;

const getTypesService = {
  async getTypes() {
    const response = await fetch(`${API_URL}/types`, {
      method: 'GET',
    });
    const data = await response.json();
    return data.types;
  },
};

export default getTypesService;
